<template>
  <div>
    <AppHeaderV2
      :show-lk="false"
      :disable-sticky="true"
      :shadow="true"
    >
      <template #left>
        <div class="b-nav-bar__panel-btns b-nav-bar__panel-btns--left">
          <c-btn
            disable-style
            :w100="false"
            class="b-nav-bar__panel-btns-item"
            @click="
              $router.push({
                path: '/',
                hash: '#i-want',
              })
            "
          >
            <div class="b-nav-bar__icon">
              <sprite
                src="sprites_arrow-m-left"
                class="b-nav-bar__icon-sprite b-nav-bar__icon-sprite--stroke"
              />
            </div>
          </c-btn>
        </div>
      </template>
      <template #title>
        Выбор меню
      </template>
      <template #right>
        <div class="b-nav-bar__icon" />
      </template>
    </AppHeaderV2>
    <div class="new-order-v3">
      <GoalsSelector
        :goals="goals"
        :value="goalInfo"
        @update:value="goalClick($event)"
      />
      <MenuPlans
        :plans="pricePlansN"
        :value="selectedPlan"
        :is-revert="goalInfo?.code === 'medium'"
        @update:value="selectPlan($event)"
      />
      <TransitionCollapse>
        <TemplateSelector
          v-if="isTemplateSelectorVisible"
          v-model:value="selectedMealsTemplate"
          :title="mealsTemplate?.title"
          :templates="mealsTemplate?.templates"
          :loading="mealsLoading"
        />
      </TransitionCollapse>
      <Packs
        :days="packs"
        :is-title-visible="false"
        :loading="isLoadingMenu"
        :selected-template="selectedTemplate"
      />
      <TransitionCollapse>
        <TemplateDaySelector
          v-if="isTemplateDaySelectorVisible"
          v-model:value="selectedDaysTemplate"
          :title="daysTemplate?.title"
          :templates="daysTemplate?.templates"
          :loading="isDaysTemplateLoading"
        />
      </TransitionCollapse>
      <DaysSelector
        :days="daysN"
        :value="selectedDay"
        @update:value="selectDay($event)"
      />

      <div
        v-if="selectedDay"
        class="new-order-v3__summ"
      >
        <SkeletonOneString
          v-if="isOrderLoading"
          :font-size="19"
          :margin="0"
        />
        <span v-else>
          <span
            v-if="fullPrice > finalPrice"
            class="new-order-v3__summ-old"
          >{{ $formatMoney(fullPrice) }}</span>
          {{ $formatMoney(finalPrice) }}&nbsp;Р в день
        </span>
      </div>
      <div class="new-order-v3-calendar">
        <div class="new-order-v3-calendar__title">
          Доставка
        </div>
        <div class="new-order-v3-calendar__content">
          <div class="new-order-v3-calendar__left">
            <DeliveryCalendar
              v-if="isDeliveryCalendarVisible"
              :has-intervals="selectedDaysTemplate2?.templateId === 1"
              type="checkout"
              drop-down-mode="modal"
              :options="{
                datePresentation: 'newOrder',
              }"
              :selected-day-params="deliveryDate.date ? deliveryDate : null"
              :delivery-days="getFormattedDeliveryDays"
              @setDeliveryDateParams="onChangeDeliveryDateParams"
              @showFaq="isShowFaqModal=true"
            />
            <div
              v-else
            >
              <SkeletonOneString
                :font-size="19"
                :margin="0"
              />
            </div>
            <div class="new-order-v3-calendar__desc">
              А дальше мы будем привозить вам коробку вкусной еды каждые 2 дня
            </div>
          </div>
          <Image
            class="new-order-v3-calendar__right"
            alt="Доставка коробка growfood"
            src="@/assets/images/box-img.png"
          />
        </div>
      </div>
      <CoreButton
        class="new-order-v3__btn"
        :loading="isOrderLoading"
        @click="testAuthThenCreateOrder"
      >
        Заказать
      </CoreButton>
    </div>
    <ModalWindow
      v-model:value="isShowDaysTemplatesWarningForm"
      class-name="template-confirm-modal"
      @modalClose="cancelDaysTemplate()"
    >
      <div class="template-confirm-modal__title">
        {{ warningFormActionText }} сб и вс?
      </div>
      <div class="template-confirm-modal__text">
        <div>
          <template v-if="selectedDaysTemplate?.templateId == 1">
            Мы передвинем доставки так, чтобы исключить выходные из вашего заказа
          </template>
          <template v-else>
            Мы вернем график доставок по умолчанию
          </template>
        </div>
        <div
          v-if="selectedDaysTemplate?.templateId == 1"
          class="template-confirm-modal__info"
        >
          Как это работает
          <div
            class="template-confirm-modal__info-icon"
            @click="showFaqModal"
          >
            <img
              :src="require('@/assets/images/icons/info.svg')"
              alt=""
            >
          </div>
        </div>
      </div>
      <div class="template-confirm-modal__btns">
        <CoreButton
          type="white"
          class="template-confirm-modal__btn"
          @click="isShowDaysTemplatesWarningForm=false, cancelDaysTemplate()"
        >
          нет
        </CoreButton>
        <CoreButton
          class="template-confirm-modal__btn"
          @click="isShowDaysTemplatesWarningForm=false, confirmDaysTemplate()"
        >
          {{ warningFormActionText }}
        </CoreButton>
      </div>
    </ModalWindow>
    <ModalWindow
      v-model:value="isShowTemplatesWarningForm"
      class-name="template-confirm-modal"
      @modalClose="cancelMealsTemplate()"
    >
      <div class="template-confirm-modal__title">
        Исключить {{ selectedMealsTemplate.templateId == 1?'обеды':'завтраки и ужины' }}?
      </div>
      <div class="template-confirm-modal__text">
        <template v-if="customDaysPoisition == 0">
          Первые дни заказа останутся без изменений. Перенесите дату первой доставки, чтобы настройки применились ко всем дням.
        </template>
        <template v-else>
          Последние дни заказа останутся без изменений. Перенесите дату первой доставки, чтобы настройки применились ко всем дням.
        </template>
      </div>
      <div class="template-confirm-modal__btns">
        <CoreButton
          type="white"
          class="template-confirm-modal__btn"
          @click="setShowTemplatesWarningForm(false), cancelMealsTemplate()"
        >
          нет
        </CoreButton>
        <CoreButton
          class="template-confirm-modal__btn"
          @click="setShowTemplatesWarningForm(false), confirmMealsTemplate()"
        >
          исключить
        </CoreButton>
      </div>
    </ModalWindow>
    <ModalWindow
      v-model:value="isShowEmtyTemplatesWarning"
      class-name="template-confirm-modal"
    >
      <div class="template-confirm-modal__title">
        Обратите внимание!
      </div>
      <div class="template-confirm-modal__text">
        Это специальное меню. Мы не смогли настроить его так, чтобы учесть все ваши предпочтения. Проверьте его перед оформлением заказа.
      </div>
      <div class="template-confirm-modal__btns">
        <CoreButton
          class="template-confirm-modal__btn template-confirm-modal__btn--full"
          @click="setShowEmtyTemplatesWarning(false)"
        >
          понятно
        </CoreButton>
      </div>
    </ModalWindow>
    <ModalWindow
      v-model:value="isShowFaqModal"
      class-name="faq-modal-v2"
    >
      <FaqModalV2
        category="meal-filter-templates"
        @close="isShowFaqModal=false"
      />
    </ModalWindow>
  </div>
</template>

<script>
import { forEach } from 'lodash'
import { useStore, mapGetters, mapMutations, mapActions } from 'vuex'
import { provide, ref, computed, watch } from 'vue'
// ui
import TransitionCollapse from '@/components/core/ui/TransitionCollapse.vue'
import ModalWindow from '@/components/core/ui/modal/ModalWindow'
import CoreButton from '@/components/core/ui/CoreButton'

// components
import AppHeaderV2 from '@/components/landing/AppHeaderV2'

import GoalsSelector from '@/components/newOrder/GoalsSelector'

import MenuPlans from '@/components/newOrder/MenuPlans/indexV5'
import TemplateSelector from '@/components/newOrder/TemplateSelector'
import TemplateDaySelector from '@/components/newOrder/TemplateDaySelector'

import Packs from '@/components/newOrder/Packs'
import DaysSelector from '@/components/newOrder/DaysSelector/indexV5'
import SkeletonOneString from '@/components/core/ui/SkeletonOneString'

import DeliveryCalendar from '@/components/core/lib/Calendar/Calendar'
import FaqModalV2 from '@/views/dashboard/modals/FaqModalV2.vue'

// composition
import deliveryCalendar from '@/composition/deliveryCalendar'
import customisationMenu from '@/composition/customisationMenu'

import templates from './composition/templates'
import pricePlans from './composition/pricePlans'

// services
import { dayjs } from '@/services/dayjs'

const WEEK_DAYS = ['вс', 'пн', 'вт', 'ср', 'чт', 'пт', 'сб']
export default {
  name: 'NewOrderMobile',
  components: {
    AppHeaderV2,
    GoalsSelector,
    MenuPlans,
    TemplateSelector,
    TemplateDaySelector,
    Packs,
    DaysSelector,
    DeliveryCalendar,
    FaqModalV2,
    SkeletonOneString,
    TransitionCollapse,
    ModalWindow,
    CoreButton,
  },

  setup () {
    // general
    const store = useStore()

    const {
      selectedPlan,
      selectedDay,
      menuDays,
      menuType,
      goal,
      plan,
      daysN,
      goalInfo,
      pricePlansN,
      selectPlan,
      selectDay,
    } = pricePlans()

    const isLoadingMenu = ref(false)

    // /general
    const {
      // data
      isLoaded,
      foodMenuAndReplacement,
      customPacks,
      errorsList,
      // computed
      getCurrentMenuDiffPrice,
      getCurrentMenuDeliveryDates,
      getCurrentCustomizationConfig,
      config,
      deliveryPrice,
      customDaysPoisition,
      hasNoCustomDays,
      // methods
      removePackFromMenuAndCustomConfig,
      addToCustomConfig,
      updateMenuAndCustomConfig,
      getCustomizationInfoMenu,
      applyTemplate,
      resetTemplate,
      setErrorsList,
    } = customisationMenu({
      isLoadingMenu,
      menuType,
    })

    provide('deliveryPrice', deliveryPrice)
    provide('getCurrentMenuDiffPrice', getCurrentMenuDiffPrice)
    // methods
    provide('updateMenuAndCustomConfig', updateMenuAndCustomConfig)
    provide('addToCustomConfig', addToCustomConfig)
    provide('removePackFromMenuAndCustomConfig', removePackFromMenuAndCustomConfig)
    provide('config', config)

    const isLoggedIn = computed(() => store.getters['client/isLoggedIn'])
    const getCustomizationInfoDays = (options) => store.dispatch('customizationInfo/getCustomizationInfoDays', options)

    const activeCity = computed(() => store.getters['city/getActive'])
    const deliveryCalendarComp = deliveryCalendar()

    const isTemplatesVisible = computed(() => store.getters['abtesting/variationActionsDomain'].kp_05_06 || false)

    const isLoading = computed(() => store.getters['customizationInfo/isLoading'])
    const deliveryDays = computed(() => store.getters['customizationInfo/deliveryDays'])
    const getCurrentMenuDeliveryDays = computed(() => {
      if (!isLoading.value && menuType.value && deliveryDays.value.length > 0) {
        return deliveryDays.value.find(
          (value) => value.menuType === menuType.value,
        )
      }

      return null
    })

    const getFirstPossibleDeliveryDate = computed(() => {
      if (!getCurrentMenuDeliveryDays.value) {
        return null
      }
      const evening = getCurrentMenuDeliveryDays.value.data.find(
        (value) => value.dayTime === 'evening',
      )
      const morning = getCurrentMenuDeliveryDays.value.data.find(
        (value) => value.dayTime === 'morning',
      )
      if (evening && morning) {
        if (
          dayjs(evening.dates[0]).unix() >=
          dayjs(morning.dates[0]).unix()
        ) {
          // Morning
          return {
            date: dayjs(morning.dates[0]).format('YYYY-MM-DD'),
            timeFrom: morning.times[0].from,
            timeTo: morning.times[0].to,
            type: 'morning',
          }
        }
        // Evening
        return {
          date: dayjs(evening.dates[0]).format('YYYY-MM-DD'),
          timeFrom: evening.times[0].from,
          timeTo: evening.times[0].to,
          type: 'evening',
        }
      }
      if (evening) {
        // Evening
        return {
          date: dayjs(evening.dates[0]).format('YYYY-MM-DD'),
          timeFrom: evening.times[0].from,
          timeTo: evening.times[0].to,
          type: 'evening',
        }
      }
      // Morning
      return {
        date: dayjs(morning.dates[0]).format('YYYY-MM-DD'),
        timeFrom: morning.times[0].from,
        timeTo: morning.times[0].to,
        type: 'morning',
      }
    })

    const updateDaysTemplateInfo = async (templateId) => {
      store.dispatch('client/setMenuCalendarConfig', {
        filter: {
          days: templateId || null,
        },
      })
      if (!isLoggedIn.value) {
        getCustomizationInfoDays({
          daysFilterTemplateId: daysFilterTemplateId.value,
        })
        store.dispatch('goals/getAndSetMenuGoals', {
          daysFilterTemplateId: daysFilterTemplateId.value,
        })
      } else {
        store.dispatch('goals/getAndSetMenuGoals')
      }
    }

    const {
      // index
      mealsLoading,
      getTemplates,
      mealsTemplate,
      selectedMealsTemplate,
      selectedMealsTemplate2,
      isShowTemplatesWarningForm,
      isShowEmtyTemplatesWarning,
      dontShowTemplatesWarningForm,
      // computed
      // methods
      setShowTemplatesWarningForm,
      setShowEmtyTemplatesWarning,
      setDontShowTemplatesWarningForm,
      confirmMealsTemplate,
      cancelMealsTemplate,
      setMealsTemplate,
      sendMealsTemplate,
      // daysTemplates
      selectedDaysTemplate,
      selectedDaysTemplate2,
      isShowDaysTemplatesWarningForm,
      daysTemplate,
      // computed
      daysFilterTemplateId,
      // methods
      setDaysTemplate,
      sendDaysTemplate,
      confirmDaysTemplate,
      cancelDaysTemplate,
    } = templates({
      goal,
      menuType,
      applyTemplate,
      resetTemplate,
      testShowTemplatesWarningForm: () => hasNoCustomDays.value,
      updateDaysTemplateInfo,
      afterSendingDaysTemplate: ({ templateId, needGetMenu }) => {
        getCustomizationInfoDays()
        store.dispatch('client/setMenuCalendarConfig', {
          filter: {
            days: templateId || null,
          },
        })
      },
    })

    const warningFormActionText = computed(() => {
      if (selectedDaysTemplate.value.templateId === 1) {
        return 'Исключить'
      }
      return 'Вернуть'
    })

    const deliveryDate = ref({
      date: null,
      timeFrom: null,
      timeTo: null,
      type: null,
    })
    const setDeliveryDateParams = (value = {}) => {
      deliveryDate.value.date = value?.date
      deliveryDate.value.timeFrom = value?.timeFrom
      deliveryDate.value.timeTo = value?.timeTo
      deliveryDate.value.type = value?.type
    }

    const menuRequestParams = computed(() => {
      return {
        cityId: activeCity.value?.id || 1,
        menuType: menuType.value,
        firstDeliveryDate: deliveryDate.value.date ? deliveryDate.value.date : getCurrentMenuDeliveryDates?.data?.[0]?.dates[0],
        dayTime: deliveryDate.value.type ? deliveryDate.value.type : 'evening',
        menuDays: menuDays.value,
        daysFilterTemplateId: daysFilterTemplateId.value,
      }
    })

    const isTemplateSelectorVisible = computed(() => {
      return isTemplatesVisible.value && (!mealsTemplate.value?.hide || mealsLoading.value)
    })
    const selectedTemplate = computed(() => {
      return mealsTemplate.value?.hide ? null : selectedMealsTemplate2.value
    })
    const isDaysTemplateLoading = ref(false)
    const isTemplateDaySelectorVisible = computed(() => {
      return isTemplatesVisible.value && (!daysTemplate.value?.hide || isDaysTemplateLoading.value)
    })

    const getMenu = async () => {
      resetTemplate()
      await getCustomizationInfoMenu({
        menuRequestParams: menuRequestParams.value,
      })
      if (selectedMealsTemplate2.value) {
        setTimeout(() => {
          applyTemplate(selectedMealsTemplate2.value.mealNumbersToRemove)
        }, 0)
      }
    }

    if (isTemplatesVisible.value) {
      getTemplates({ menuType: menuType.value })
    }
    if (getFirstPossibleDeliveryDate.value) {
      setDeliveryDateParams(getFirstPossibleDeliveryDate.value)
    }
    if (menuType.value && menuDays.value && getFirstPossibleDeliveryDate.value) {
      getMenu()
    }
    watch(menuType, (newMenuType) => {
      if (isTemplatesVisible.value) {
        getTemplates({ menuType: newMenuType })
      }
    })
    watch(getFirstPossibleDeliveryDate, () => {
      setDeliveryDateParams(getFirstPossibleDeliveryDate.value)
    })
    watch([menuType, menuDays, getFirstPossibleDeliveryDate], () => {
      if (
        menuType.value &&
        menuDays.value &&
        daysN.value.findIndex(item => item.numberOfMealDays === menuDays.value) >= 0 &&
        getFirstPossibleDeliveryDate.value
      ) {
        getMenu()
      }
    })

    return {
      isLoggedIn,
      activeCity,
      isTemplatesVisible,
      // selectedPlan
      selectedPlan,
      selectedDay,
      menuDays,
      menuType,
      daysN,
      goal,
      plan,
      goalInfo,
      pricePlansN,
      selectPlan,
      selectDay,
      // end selectedPlan

      deliveryDate,
      setDeliveryDateParams,
      menuRequestParams,
      getMenu,
      getCustomizationInfoDays,
      getCurrentMenuDeliveryDays,
      // ...templatesComp,
      mealsLoading,
      // ...mealsTemplatesComp,
      mealsTemplate,
      selectedMealsTemplate,
      selectedMealsTemplate2,
      isShowTemplatesWarningForm,
      isShowEmtyTemplatesWarning,
      dontShowTemplatesWarningForm,
      // computed
      // methods
      setShowTemplatesWarningForm,
      setShowEmtyTemplatesWarning,
      setDontShowTemplatesWarningForm,
      confirmMealsTemplate,
      cancelMealsTemplate,
      setMealsTemplate,
      sendMealsTemplate,
      // / mealsTemplatesComp,
      // ...daysTemplatesComp,
      isLoading,
      selectedDaysTemplate,
      selectedDaysTemplate2,
      isShowDaysTemplatesWarningForm,
      daysTemplate,
      // computed
      daysFilterTemplateId,
      warningFormActionText,
      isTemplateSelectorVisible,
      isTemplateDaySelectorVisible,
      selectedTemplate,
      // methods
      setDaysTemplate,
      sendDaysTemplate,
      confirmDaysTemplate,
      cancelDaysTemplate,
      // / daysTemplatesComp,
      ...deliveryCalendarComp,
      // customisationMenu
      // data
      isLoadingMenu,
      isLoaded,
      foodMenuAndReplacement,
      customPacks,
      // computed
      getCurrentMenuDiffPrice,
      getCurrentMenuDeliveryDates,
      getCurrentCustomizationConfig,
      deliveryPrice,
      customDaysPoisition,
      hasNoCustomDays,
      // methods
      getCustomizationInfoMenu,
      applyTemplate,
      resetTemplate,
      errorsList,
      setErrorsList,
      // /customisationMenu
    }
  },
  // TODO: DEV-12010 переделать на composition API + разбить на файлы
  data () {
    return {
      isOrderLoading: false,
      menu: null,
      isFloatOrderBottom: false,
      isShowFaqModal: false,
    }
  },
  computed: {
    ...mapGetters({
      targets: 'goals/goals',
      isLoadingGoals: 'goals/isLoading',
      variationActionsDomain: 'abtesting/variationActionsDomain',
    }),

    goals () {
      // проверка для кастомников с одной целью похудейка
      const goalsTest = this.targets?.filter(goal => goal.id !== 1)
      return goalsTest && goalsTest.length ? goalsTest : this.targets?.filter(goal => goal.id === 1)
    },

    getFormattedDeliveryDays () {
      if (this.getCurrentMenuDeliveryDays) {
        return this.formatCalendarDays(this.getCurrentMenuDeliveryDays?.data)
      }
      return null
    },

    isDeliveryCalendarVisible () {
      return !this.isLoading && !this.isLoadingMenu && this.menuType && this.getFormattedDeliveryDays
    },

    packs () {
      const daysInfo = []
      if (this.foodMenuAndReplacement) {
        let lastDay = this.$date(this.foodMenuAndReplacement.days[0].date)
        forEach(this.foodMenuAndReplacement.days, (day) => {
          let dayInfo = {}
          const date = this.$date(day.date)
          const emptyDaysCount = date.diff(lastDay, 'day')
          if (emptyDaysCount > 1) {
            const emptyDays = []
            for (let index = 1; index < emptyDaysCount; index++) {
              emptyDays.push(WEEK_DAYS[this.$date(lastDay.add(index, 'day')).day()])
            }
            daysInfo.push({
              isEmpty: true,
              dayOfWeek: emptyDays.join(' и '),
            })
          }
          dayInfo = {
            dayOfWeek: WEEK_DAYS[date.day()],
            ccal: 0,
            count: 0,
            bju: {
              b: 0,
              j: 0,
              u: 0,
            },
          }
          let ccalSumm = 0
          let countSumm = 0
          dayInfo.packs = []
          forEach(day.items, ({ onDesck, position, title: meal, major }) => {
            if (onDesck && onDesck.length === 0 && major && major.length > 0) {
              dayInfo.packs.push({ meal, position })
            } else {
              onDesck.forEach((item, index) => {
                const { id } = item
                const pack = this.foodMenuAndReplacement.packs.find(({ id: packId }) => packId === id)
                const {
                  calories: ccal,
                  name,
                  photoResizes: { '2x': img },
                  price,
                  proteins: b,
                  fats: j,
                  carbs: u,
                } = pack
                ccalSumm += ccal
                countSumm++
                dayInfo.packs.push({
                  meal,
                  ccal,
                  name,
                  img,
                  id,
                  position,
                  price,
                  index,
                  bju: { b, j, u },
                })

                dayInfo.bju = {
                  b: dayInfo.bju.b + b,
                  j: dayInfo.bju.j + j,
                  u: dayInfo.bju.u + u,
                }
              })
            }
          })
          dayInfo.count = countSumm
          dayInfo.ccal = ccalSumm
          dayInfo.customizable = day.customizable
          dayInfo.date = day.date
          daysInfo.push(dayInfo)
          lastDay = date
        })
      }
      return daysInfo
    },

    fullPrice () {
      return this.selectedDay.local.oldPrice + (this.getCurrentMenuDiffPrice + this.deliveryPrice) / this.menuDays
    },
    finalPrice () {
      if (this.isLoadingMenu) {
        return this.selectedDay.local.price
      }
      return this.selectedDay.local.price + this.diffPriceWithDiscounts
    },
    diffPriceWithDiscounts () {
      const percentDiscount = this.selectedDay?.promoInfo?.discounts?.find(
        discount => discount.discountType === 'percent',
      )?.discountValue
      if (percentDiscount) {
        return (
          (this.getCurrentMenuDiffPrice * ((100 - percentDiscount) / 100) +
          this.deliveryPrice) / this.menuDays
        )
      }
      return (this.getCurrentMenuDiffPrice + this.deliveryPrice) / this.menuDays
    },

    formatCustomPacks () {
      const result = []
      for (const item of this.getCurrentCustomizationConfig) {
        const {
          remove,
          mealDate,
          mealNumber,
          packId,
        } = item

        result.push({
          remove,
          mealDate,
          mealNumber,
          packId,
        })
      }
      return result
    },

    getCustomForCurrentOrder () {
      const mealDates = []
      for (let i = 0; i <= this.menuRequestParams.menuDays; i++) {
        mealDates.push(this.$date(this.menuRequestParams.firstDeliveryDate).add(i, 'day').format('YYYY-MM-DD'))
      }

      const currentOrderPacks = this.formatCustomPacks.filter(value => mealDates.find(day => day === value.mealDate))

      return currentOrderPacks || []
    },
  },
  watch: {
    errorsList () {
      if (this.errorsList?.length > 0) {
        this.errorsList.forEach((message) => {
          this.toast({ group: 'error', title: message })
        })
        setTimeout(() => {
          this.setErrorsList()
        }, 5000)
      }
    },
  },
  mounted () {
    this.sendGTMMarkupEvent({
      block: 'LandingNewOrder',
      element: 'Block',
      action: 'View',
      details: '',
    })
    this.$nextTick(() => {
      window.scroll(0, 0)
    })

    this.onScrollPage()
    document.addEventListener('scroll', this.onScrollPage)
    window.addEventListener('resize', this.onScrollPage)
  },

  beforeUnmount () {
    document.removeEventListener('scroll', this.onScrollPage)
    window.removeEventListener('resize', this.onScrollPage)
  },

  methods: {
    ...mapMutations({
      openModal: 'modals/openModal',
    }),

    ...mapActions({
      getAndSetMenuGoals: 'goals/getAndSetMenuGoals',
      createOrderStage1: 'orders/createOrderStage1',
      routeCreateWithToken: 'orders/routeCreateWithToken',
      createOrder: 'order/createOrder',
      firebasePerformanceCustomTraceStart: 'analytics/firebasePerformanceCustomTraceStart',
    }),
    goalClick (goalItem) {
      this.sendGTMMarkupEvent({
        block: 'NewOrderNav',
        element: 'GoalsLink',
        action: 'Click',
      })
      this.$router.replace({
        name: 'NewOrder',
        params: {
          goal: goalItem.code,
        },
      })
    },

    onChangeDeliveryDateParams (value) {
      this.setDeliveryDateParams(value)
      this.getMenu()
    },

    onScrollPage () {
      const newOrderBottonPos = this.$refs['new-order-bottom']?.offsetTop || 0
      this.isFloatOrderBottom = window.scrollY + window.innerHeight <= newOrderBottonPos
    },

    getOrderRequestObject () {
      const pricePlan = this.selectedDay
      const mealDays = pricePlan?.numberOfMealDays
      return {
        client: {
          cityId: this.activeCity.id || 1,
        },

        deliveriesStartDate: this.deliveryDate?.date || undefined,

        deliveriesStartDateType: this.deliveryDate?.type || 'evening',

        deliveriesStartDateIntervals: {
          timeFrom: this.deliveryDate?.timeFrom || '18:00',
          timeTo: this.deliveryDate?.timeTo || '23:00',
        },

        subscriptionId_H: pricePlan?.subscriptionId_H || undefined,

        order: {
          price_plan_id: this.selectedPlan?.pricePlan?.id,
          mealDays: mealDays,
        },

        customization_info: {
          custom_packs: this.getCustomForCurrentOrder || undefined,
        },

        promocode: pricePlan?.promoInfo?.promocode || undefined,
      }
    },

    async afterLogIn ({ afterCreateOrder = () => {}, payload = null }) {
      this.firebasePerformanceCustomTraceStart('createOrder' + payload.order.mealDays)
      try {
        this.isOrderLoading = true
        if (!this.mealsTemplate?.hide) {
          await this.sendMealsTemplate({ toast: false })
        }
        if (!this.daysTemplate?.hide) {
          await this.sendDaysTemplate({ toast: false })
        }
        this.onCreateOrder({ afterCreateOrder, payload })
      } catch (error) {
        console.log('error', error)
        const {
          data: {
            message = '',
            messages,
          } = {},
        } = error || {}
        if (message) {
          this.toast({ group: 'error', title: `${message}` })
        }
        if (messages) {
          messages.forEach((message) => {
            this.toast({ group: 'error', title: message })
          })
        }
        this.isOrderLoading = false
      }
    },
    // afterCreateOrder - для закрытия модалки авторизации только после создания заказа и перехода на него
    async onCreateOrder ({ afterCreateOrder = () => {}, payload = null }) {
      this.sendGTMMarkupEvent({
        block: 'LandingNewOrder',
        element: 'CreateOrder',
        action: 'Click',
        details: this.menuType,
      })
      try {
        this.isOrderLoading = true
        const response = await this.createOrder(payload)
        const { order = {}, success, messages, errorCode } = response
        this.$gtm.trackEvent({
          event: 'order_authorized',
          product_price: order.menuPrice,
          product_menu_type: order.menuType,
          product_meal_days: order.numberOfDays,
          product_city_id: order.cityId,
          order_id: order.id_H,
          order_price: order.debPrice,
          anti_double_handled: response.anti_double_handled,
        })

        if (success) {
          const { id_H: idH = '' } = order

          await this.$router.push({
            name: 'LandingNewOrder',
            params: {
              orderId: idH,
              orderJson: order ? JSON.stringify(order) : null,
            },
          })

          if (typeof afterCreateOrder === 'function') {
            afterCreateOrder()
          }
        } else {
          if (errorCode) {
            if (messages) {
              messages.forEach((message) => {
                this.toast({ group: 'error', title: message })
              })
            }
          }
        }
      } catch (error) {
        const {
          data: {
            message = '',
            messages,
          } = {},
        } = error || {}
        if (message) {
          this.toast({ group: 'error', title: `${message}` })
        }
        if (messages) {
          messages.forEach((message) => {
            this.toast({ group: 'error', title: message })
          })
        }
      } finally {
        if (typeof afterCreateOrder === 'function') {
          afterCreateOrder()
        }
        this.isOrderLoading = false
      }
    },
    testAuthThenCreateOrder () {
      this.sendGTMMarkupEvent({
        block: 'LandingNewOrder',
        element: 'CreateOrderButton',
        action: 'Click',
      })
      this.$store.dispatch('analytics/singleEvent', 'mob_order_place', { root: true })

      const payload = this.getOrderRequestObject()

      // условие при клике авторизованного пользователя просто создавать заказ
      if (this.isLoggedIn) {
        this.afterLogIn({ payload })
        this.$gtm.trackEvent({
          event: 'go_to_step',
          step_number: 2,
          step_option: '',
          form_placement: 'basket',
        })
        return
      }
      // условие при клике не авторизованного пользователя
      // открыть окно регистрации
      // пользователь уже ввел телефон -> показываем окно с вводом смс
      if (this.phone) {
        this.openModal({
          name: 'EnterSms',
          params: {
            phone: this.phone,
            openCheckoutForm: true,
            // после регистрации создаем выбранный пользоватлемем заказ
            afterLogIn: async (afterCreateOrder) => {
              await this.afterLogIn({ afterCreateOrder, payload })
            },
          },
        })
        return
      }
      // пользователь не ввел телефон -> показываем окно с вводом телефона
      this.openModal({
        name: 'EnterPhone',
        params: {
          openCheckoutForm: true,
          menuDays: this.menuDays,
          pricePlanId: this.selectedPlan?.pricePlan?.id,
          afterLogIn: async (afterCreateOrder) => {
            // после регистрации создаем выбранный пользоватлемем заказ
            await this.afterLogIn({ afterCreateOrder, payload })
          },
          price: this.finalPrice,
        },
      })
    },
    showFaqModal () {
      this.isShowFaqModal = true
    },
  },
}
</script>

<style lang="scss">
.new-order-v3 {
  margin-top: 0.08rem;
  font-size: 0.16rem;
  line-height: 0.2rem;

  &__summ {
    // margin-bottom: .24rem; // если не прикреплена
    margin: 0 .16rem 0.32rem;
    font-weight: 600;
    font-size: 0.2rem;
    line-height: 0.24rem;
  }
  &__summ-old {
    font-weight: 500;
    text-decoration-line: line-through;
    color: map-get($colors, 'grey_30');
  }
  &__btn {
    position: relative;
    width: calc(100% - .32rem);
    height: auto !important;
    margin: 0 .16rem .64rem;
    outline: none !important;
    border: none !important;
    border-radius: 0.16rem;
    padding: 0.14rem;
    display: flex;
    justify-content: center;
    align-items: center;
    background: map-get($colors, 'default');
    border-color: map-get($colors, 'default');
    color: map-get($colors, 'white');
    transition: background-color 0.3s;
    font-weight: 600;
    font-size: 0.14rem;
    line-height: 0.2rem;
    letter-spacing: 0.01rem;
    text-transform: uppercase;
  }
  &__btn-loader {
    height: 0.2rem;
  }
}

.new-order-v3 {

  .core-dropdown-v2__button-left-icon {
    display: none;
  }

  .core-dropdown-v2__button {
    justify-content: flex-start;

    padding: unset;
    border: unset;
    color: map-get($colors, 'default');

    .core-dropdown-v2__content-slot {
      width: unset;
      font-size: 0.14rem;
      font-style: normal;
      font-weight: 600;
      line-height: normal;
    }

    .select-day-presentation-title {
      padding-left: unset;
    }
  }
  .core-dropdown-v2__button-right-icon {
    width: unset;
    margin-left: 0.04rem;
    color: map-get($colors, 'default');

    .c-icon {
      width: 0.16rem;
      height: 0.16rem;
    }
  }

  .core-dropdown-v2__content.core-dropdown-v2__padded-content {
    padding: 0;
  }

  .core-dropdown-v2__mode-modal {
    .core-dropdown-v2__content {
      top: 0.64rem;
      left: 0.08rem;
      z-index: 130;
      overflow: hidden;
      width: calc(100% - 0.16rem);
    }
  }
}

.slide-bottom-leave-active,
.slide-bottom-enter-active {
  transition: all 0.4s ease;
}

.slide-bottom-enter-from,
.slide-bottom-leave-to {
  transform: translate(0, 100%);
}

.slide-bottom-enter-to,
.slide-bottom-leave-from {
  transform: translate(0, 0);
}
.template-confirm-modal {
  font-size: .16rem;
  margin: .16rem;
  width: calc(100% - .32rem);
  padding: .24rem;
  padding-top: .32rem;
  text-align: center;
  &__title {
    margin-bottom: .16rem;
    @include typography('h2', 'bold');
  }
  &__text {
    margin-bottom: .32rem;
    @include typography('b1', 'medium');
  }
  &__info {
    color: map-get($colors, 'default');
    margin-top: .08rem;
    @include typography('b1', 'bold');
    &-icon{
      display: inline-block;
      width: 0.2rem;
      height: 0.2rem;
      transform: translateY(0.04rem);
    }
  }
  &__btns {
    display: flex;
    *:not(:last-child) {
      margin-right: .12rem;
    }
  }
  &__btn {
    width: 50%;
    &--full {
      width: 100%;
    }
  }
}
.new-order-v3-calendar {
  margin: 0 .16rem .32rem;
  &__title {
    margin-bottom: .16rem;
    color: var(--main-black, #0D0D0D);
    font-size: 0.2rem;
    font-style: normal;
    font-weight: 600;
    line-height: 0.24rem; /* 120% */
  }
  &__content {
    padding: 0.07rem 0.16rem;
    display: flex;
    flex-direction: row;
    align-items: center;
    border-radius: 0.16rem;
    background: var(--greyscale-grey-4, #F5F5F5);
  }
  &__left {
    width: 100%;
    margin-right: .16rem;
  }
  &__desc {
    margin-top: .07rem;
    color: var(--greyscale-grey-60, #666);
    font-size: 0.12rem;
    font-style: normal;
    font-weight: 400;
    line-height: 0.16rem; /* 133.333% */
    letter-spacing: 0.001rem;
  }
  &__right {
    width: 0.73rem;
    height: 0.66rem;
  }
}
</style>
